import { FormField, FormItem, SvgName } from "@ac-expo/ui-components";
import { Control, FieldValues, Path } from "react-hook-form";
import { SignupSelect } from "./SignupSelect";

export const rolesCards: {
  desc: string;
  title: string;
  svgName: SvgName;
  isProfessional: boolean;
}[] = [
  {
    desc: "Particulier",
    title: "Particulier",
    svgName: "presentation",
    isProfessional: false,
  },
  {
    desc: "Professionnel",
    title: "Professionnel",
    svgName: "briefcase",
    isProfessional: true,
  },
];

type RoleSelectorProps<TFieldValues extends FieldValues> = {
  control: Control<TFieldValues>;
  name: Path<TFieldValues>;
  hasError?: boolean;
};

export const RoleSelector = <TFieldValues extends FieldValues>({
  control,
  name,
  hasError,
}: RoleSelectorProps<TFieldValues>) => {
  return (
    <FormField
      control={control}
      name={name}
      render={({ field }) => (
        <FormItem className="grid grid-cols-2 gap-4">
          {rolesCards.map((card) => (
            <SignupSelect
              key={card.isProfessional.toString()}
              desc={card.desc}
              title={card.title}
              svgName={card.svgName}
              selected={field.value === card.isProfessional}
              onClick={() => field.onChange(card.isProfessional)}
              className={
                hasError
                  ? "rounded-[5px] ring-1 ring-destructive focus-visible:ring-destructive focus-visible:ring-offset-1 focus-visible:ring-offset-background"
                  : undefined
              }
            />
          ))}
        </FormItem>
      )}
    />
  );
};
